
window._ = require('lodash');

window.$ = window.jQuery = require('jquery');

require('bootstrap-sass');

window.moment = require('moment-timezone');
moment.locale('pt-br');

import Vue from 'vue';
window.Vue = Vue;

import Vuex from 'vuex';
Vue.use(Vuex);

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import uuid from 'uuid/v1';
window.uuid = uuid;

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
Vue.use(VueTelInput);

const bugsnag = require('bugsnag-js');
const bugsnagClient = bugsnag('b73522c3d6bf69f778f859456c239405');
const bugsnagVue = require('bugsnag-vue');
bugsnagClient.use(bugsnagVue(Vue));
window.bugsnagClient = bugsnagClient;

var infiniteScroll =  require('vue-infinite-scroll');
Vue.use(infiniteScroll);

let clickOutside =  require('vue-click-outside');
Vue.directive('click-outside', clickOutside);

import axios from 'axios';
window.axios = axios;

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);


import draggable from 'vuedraggable';
Vue.component('draggable',draggable);

/*
import MaskedInput from 'vue-masked-input';
Vue.component('masked-input', MaskedInput);
*/

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

import VueClip from 'vue-clip';
Vue.use(VueClip);

import Toasted from 'vue-toasted';
Vue.use(Toasted);

import Buefy from 'buefy'
//import 'buefy/lib/buefy.css'
Vue.use(Buefy)

window.Sortable = require('sortablejs');
window.move = require('array.prototype.move');
window.async = require('async');
window.croppie = require('croppie');

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

window.axios.defaults.headers.common = {
    //'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
};

import Pusher from 'pusher-js'
import Echo from "laravel-echo"

if(!window.disable_pusher){
	if(window.Laravel['environment']=='production'){

		window.Echo = new Echo({
			broadcaster: 'pusher',
			key: '612a570b3e387d07b72e',
			cluster: 'sa1',
			encrypted: true,
			auth: {
				headers: {
					Authorization: 'Bearer ' + window.user.api_token,
				},
			},
		});
	
	} else {
	
		window.Echo = new Echo({
			broadcaster: 'pusher',
			key: '4d092cac8d0e79df3da5',
			cluster: 'sa1',
			encrypted: true,
			auth: {
				headers: {
					Authorization: 'Bearer ' + window.user.api_token,
				},
			},
		});
		
		Pusher.logToConsole = false;
	
	}
}

import {RequestQueue} from './classes';
window.queue = new RequestQueue();

import request from './request';
window.request = request;